import React from 'react'
import { useTranslation } from 'react-i18next'

const InvoiceDataCard = ({ invoiceData }) => {

  const { t } = useTranslation();

  return (
    <div>
      <div className='row justify-content-center'>
        <div className='justify-content-center mt-2'>
          <div>
            <div className='panel-header-title'>{t('invoice_details')}</div>
            <div className='col-auto ms-1'>
              {invoiceData.symbolCust} <br />
              <br />
              {invoiceData.addressStreet} <br />
              {invoiceData.addressZipCity} <br />
              {invoiceData.taxId ? 'NIP: ' + invoiceData.taxId : ''}<br />
              {invoiceData.regon ? 'Regon: ' + invoiceData.regon : ''}<br />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvoiceDataCard